// Access (role permission) name for this module.
export const FORM_NAME = 'Miscellaneous Receipt';
export const MISC_RECEIPT_BASE = '/Lease/Management/Lease/MiscellaneousReceipt';
export const MISC_RECEIPT_CREATE = `${MISC_RECEIPT_BASE}/create`;
export const LEAVE_MESSAGE = 'You have allocated lines that are not saved. Leave this page?';

// Read synchronously so "no access" is not flashed before an effect runs.
export const readPermission = (formName = FORM_NAME) => {
    try {
        const stored = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        return stored.find((acc) => acc.formName === formName);
    } catch (error) {
        return undefined;
    }
};
